import * as Icon from 'react-feather';
export const expertiseData = [
    {
        title:'Developing',
        Icon: Icon.Monitor
    },
    {
        title:'React Js',
        Icon: Icon.StopCircle
    },
    {
        title:'WordPress',
        Icon: Icon.Video
    },
    {
        title:'Shopify',
        Icon: Icon.Coffee
    },
    {
        title:'BootStrap',
        Icon: Icon.Music
    },
    {
        title:'SEO',
        Icon: Icon.Watch
    },
    {
        title:'Github',
        Icon: Icon.Box
    },
    {
        title:'Sports',
        Icon: Icon.Target
    },
    {
        title:'Nodejs',
        Icon: Icon.PenTool
    },
    {
        title:'SQL',
        Icon: Icon.Book
    },
    {
        title:'Android',
        Icon: Icon.Smartphone
    },
    {
        title:'Social Media Marketing',
        Icon: Icon.Activity
    },
]
export const servicesData = [
    {
        title:'UX / UI Design',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Airplay
    },
    {
        title:'Web Designer',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Aperture
    },
    {
        title:'React js',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Camera
    },
    {
        title:'Social Media Marketing',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Compass
    },
    {
        title:'Web Dev',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Settings
    },
    {
        title:'E-Commerce/Shopify',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Watch
    },

]
export const project = [
   {
    image: '/images/works/1.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/2.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/3.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/4.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/5.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/6.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/7.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/8.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   }
   
]
export const blogData = [
    {
        image:"/images/blog/01_giglink.jpg",
        title:'Web Development Tips & Tutorials',
        desc:'earn practical coding techniques, tools, and frameworks from real-world experience.'
    },
    {
        image:"/images/blog/01_techwind.jpg",
        title:'Latest Trends in Web Design & Tech',
        desc:'Stay updated with evolving UI/UX styles, modern stacks, and emerging web technologies.'
    },
    {
        image:"/images/blog/01_upwind.jpg",
        title:'Project Highlights & Dev Updates',
        desc:'Behind-the-scenes looks at my recent projects, challenges, and solutions.'
    },
]
export const review = [
    {
        name:'Thomas & Farri',
        designation:'Manager',
        image:'/images/Testimonial/testimonial1.png',
        desc:"Amazing NumanRp my work! Delivered my website quickly, clean code, responsive design. Highly recommended for anyone needing a professional web developer!"
    },
    {
        name:'Henry & Gravity',
        designation:'Manager',
        image:'/images/Testimonial/testimonial2.png',
        desc:"Excellent developer! Understood my requirements perfectly. Created a fast, mobile-friendly website that looks fantastic. Will definitely hire again! "
    },
    {
        name:'Janifar & Jhon',
        designation:'Manager',
        image:'/images/Testimonial/testimonial3.png',
        desc:"Very skilled and professional web developer. Communicated clearly, delivered on time, and made all requested updates perfectly. Highly satisfied client!"
    },
    {
        name:'Sarry Dev',
        designation:'Manager',
        image:'/images/Testimonial/testimonial4.png',
        desc:"Built my eCommerce site exactly how I imagined. Smooth process, creative solutions, and amazing attention to detail. Thank you!"
    },
    {
        name:'Thomas Nigoria',
        designation:'Manager',
        image:'/images/Testimonial/testimonial5.png',
        desc:"Outstanding job! Fast, reliable, and delivered a beautiful, SEO-optimized website. Truly a talented developer who cares about quality work."
    },
]

